module.exports = __webpack_public_path__ + "img/camera-coffee-composition.e327160b.jpg";